import {
  Button,
  Group,
  Modal,
  Stack,
  TextInput,
  Textarea,
} from '@mantine/core';
import { useEffect, useState } from 'react';

type WorkspaceEditInfoModalProps = {
  opened: boolean;
  onClose: () => void;
  initialName: string;
  initialDescription?: string;
  onSave: (values: { name: string; description?: string }) => void;
};

export function WorkspaceEditInfoModal({
  opened,
  onClose,
  initialName,
  initialDescription,
  onSave,
}: WorkspaceEditInfoModalProps) {
  const [name, setName] = useState(initialName);
  const [description, setDescription] = useState(initialDescription ?? '');

  useEffect(() => {
    if (!opened) return;
    setName(initialName);
    setDescription(initialDescription ?? '');
  }, [opened, initialName, initialDescription]);

  const handleSave = () => {
    const trimmedName = name.trim();
    if (!trimmedName) return;

    onSave({
      name: trimmedName,
      description: description.trim() || undefined,
    });
    onClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title='Modifica informazioni'
      centered
    >
      <Stack gap='md'>
        <TextInput
          label='Titolo analisi'
          value={name}
          onChange={event => setName(event.currentTarget.value)}
          placeholder='Es. Trial BECOME - confronto gruppo'
          required
        />
        <Textarea
          label='Descrizione'
          value={description}
          onChange={event => setDescription(event.currentTarget.value)}
          placeholder='Descrizione opzionale'
          autosize
          minRows={2}
        />
        <Group justify='flex-end'>
          <Button variant='subtle' onClick={onClose}>
            Annulla
          </Button>
          <Button onClick={handleSave} disabled={!name.trim()}>
            Salva
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
